import _groupBy from 'lodash/groupBy';
import React from 'react';

import Fieldset from './Fieldset';

class Steps extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      currentStep: 1
    };

    // These bindings are necessary to make `this` work in the callbacks
    this.prevStep = this.prevStep.bind(this);
    this.nextStep = this.nextStep.bind(this);
  }

  prevStep() {
    this.setState({
      currentStep: this.state.currentStep - 1
    });
  }

  nextStep() {
    this.setState({
      currentStep: this.state.currentStep + 1
    });
  }

  render() {
    const { currentStep } = this.state;
    const { fields, formId, contentArticleFormId, defaultElementsForLastStep } = this.props;

    if (!fields.id) {
      return null;
    }

    const steps = [];
    const groupedFieldsets = _groupBy(fields.fieldsets, 'step');

    for (const step in groupedFieldsets) {
      steps.push(
        groupedFieldsets[step].map((fieldset, index) => (
          <Fieldset
            key={`fieldset-form-${formId || fields.id}-${index}`}
            fields={fields}
            fieldset={fieldset}
            formId={formId}
            contentArticleFormId={contentArticleFormId}
          />
        ))
      );
    }

    steps[steps.length - 1] = steps[steps.length - 1].concat(defaultElementsForLastStep);

    return (
      <div className="form-steps">
        {steps.map((step, index) => (
          <div
            className={`form-step${index + 1 !== currentStep ? ' hidden' : ''}`}
            data-step={index + 1}
            key={`form-step-${index + 1}`}
          >
            {steps.length > 1 && (
              <div className="color-secondary margin-bottom-xxs">
                Schritt: {index + 1} von {steps.length}
              </div>
            )}
            {step}
            {steps.length > 1 && (
              <div className="form-step--buttons">
                {currentStep > 1 ? (
                  <button type="button" className="btn btn-invert" onClick={this.prevStep}>
                    Zurück
                  </button>
                ) : (
                  <div />
                )}
                {currentStep < steps.length && (
                  <button type="button" className="btn btn-invert" onClick={this.nextStep}>
                    Weiter
                  </button>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
}

Steps.propTypes = {
  fields: React.PropTypes.object.isRequired,
  formId: React.PropTypes.string.isRequired,
  contentArticleFormId: React.PropTypes.string.isRequired,
  defaultElementsForLastStep: React.PropTypes.array.isRequired
};

export default Steps;



// WEBPACK FOOTER //
// ./components/forms/Steps.js